import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeContentEditor,
  handleContentEditorData,
  handleDataSave,
} from "../../features/contentEditor/contentEditor";
import CloseIcon from "../icons/CloseIcon";
import "./contenteditor.css";

import { RootState } from "../../app/store";
import CkEditor from "./Ckeditor";

const ContentEditor: FC = () => {
  const content = useSelector(
    (state: RootState) => state.contentEditor.content
  );
  const [contentData, setContentData] = useState<string>(content || "");

  const dispatch = useDispatch();

  const onBoxContentChangeHandler = (newValue: string, editor: any) => {
    console.log("newValue =>", newValue);
    setContentData(newValue);
  };

  const handleSubmitContent = () => {
    dispatch(handleContentEditorData(contentData));
    dispatch(handleDataSave(true));
    if (contentData.length > 0) {
      dispatch(closeContentEditor());
    }
  };

  return (
    <div className="image__popup--container">
      <div className="image__popup--row">
        <div className="image__popup--col">
          <div className="image__popup--wrapper">
            <div className="p-6">
              {/* <CKEditorBuild
                value={contentData}
                onEventChangeHandler={onBoxContentChangeHandler}
              /> */}
              <CkEditor
                value={contentData}
                onEventChangeHandler={onBoxContentChangeHandler}
              />
            </div>
          </div>
          <div
            className="image__popup--close-btn"
            onClick={() => dispatch(closeContentEditor())}
          >
            <CloseIcon />
          </div>
          <div>
            <div
              onClick={handleSubmitContent}
              className="mainSliderForm__btn flex items-center justify-center cursor-pointer"
            >
              save
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentEditor;
